import _ from 'lodash';
import moment from 'moment';
import template from './am-operators-list-table.html';
import { Paging, OperatorsOrdersBy } from '../../core/models/am-helper.model';
import { AmSelectListController } from '../am-list-table-base.controller';

class AmOperatorsListTableController extends AmSelectListController {
  constructor(amAssignmentService, amOperatorsService, usersService, $filter) {
    'ngInject';

    super();
    this.opService = amOperatorsService;
    this.assignmentStatus = amAssignmentService.assignmentStatus;
    this.usersService = usersService;
    this.sortedBy = OperatorsOrdersBy.name;
    // paging
    this.paging = new Paging(10, 1);
    this.$filter = $filter;
    this.operatorsTableList = [];
    this.hasAccessOperatorExpiryFeature = false;
  }

  $onInit() {
    this.hasAccessOperatorExpiryFeature = this.usersService.hasRequiredFeatures([
      'access.operator_expiry',
    ]);
  }

  $onChanges() {
    // Project the operator model into a simpler structure for retrieving the secondary group
    this.operatorsTableList = this.list.map((op) => {
      const secondaryGroups = _.get(op.security_context, 'groups', []).map((group) => group.name);
      if (this.view === 'asset-view') {
        return {
          ...op,
          secondary_groups: secondaryGroups,
        };
      }
      return {
        ...op,
        secondary_groups: secondaryGroups,
        expiry_in: this.getExpiryInDays(op.attrs.expiry),
      };
    });

    this.sortByColumn();
  }

  get sortExpr() {
    return `${this.sortedBy.desc ? '-' : '+'}${this.sortedBy.attr}`;
  }

  sortByColumn(name) {
    if (name) {
      const { attr, desc } = this.sortedBy || {};
      this.sortedBy = {
        attr: name,
        desc: name === attr && !desc,
      };
    }

    if (this.sortedBy.attr === 'attrs.expiry') {
      this.operatorsTableList = this.operatorsTableList.sort((a, b) => {
        if (a.expiry_in === null && b.expiry_in === null) return 0;
        if (a.expiry_in === null) return 1;
        if (b.expiry_in === null) return -1;

        if (this.sortedBy.desc) return b.expiry_in - a.expiry_in;
        return a.expiry_in - b.expiry_in;
      });
    } else {
      this.operatorsTableList = this.$filter('orderBy')(
        this.operatorsTableList,
        this.sortedBy.attr,
        this.sortedBy.desc,
      );
    }
  }

  get sortDirIcon() {
    return this.sortedBy && this.sortedBy.desc ? 'z-arrowdown' : 'z-arrowup';
  }

  getExpiryInDays(expirydate) {
    if (expirydate == null || expirydate == undefined) {
      return null;
    }
    let expiryDate = moment(expirydate);
    let currenDate = moment();
    return expiryDate.diff(currenDate, 'days');
  }

  //takes expiry days as input
  getExpiryTextcssClass(expiryIn) {
    if (expiryIn > 20 && expiryIn <= 30) {
      return 'expiry-msg expiry-msg_yellow';
    } else if (expiryIn > 10 && expiryIn <= 20) {
      return 'expiry-msg expiry-msg_orange';
    } else if ((expiryIn >= 0 && expiryIn <= 10) || expiryIn < 0) {
      return 'expiry-msg expiry-msg_red';
    }
    return '';
  }
}

export default {
  template,
  controller: AmOperatorsListTableController,
  controllerAs: 'opsTbVm',
  bindings: {
    list: '<',
    total: '<',
    onView: '&',
    selectMode: '<',
    view: '@',
    selected: '=?', // object will hold selected as {id:item}
    isGroupVisible: '<',
  },
};
